import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme, useTheme } from "@mui/material";
import Link from "next/link";
import { FC } from "react";

import { Props } from "~/components/category/[id]/database/database-panel/index";
import { PC_PANEL_WIDTH } from "~/components/category/[id]/database/database-panel/lib";
import { fixedHeight, fixedWidth } from "~/lib/client/design";
import { engFont } from "~/lib/client/fonts";
import { formatDate } from "~/lib/graphql/graphqlClient";

const PcDatabasePanel: FC<Props> = ({ database }) => {
  const theme = useTheme();
  return (
    <Link css={rootStyle(theme)} href={`/database/${database.id}`}>
      <div>
        <CategoryListContainer>
          {database.categories.map((category) => (
            <Link
              key={category.id}
              css={categoryStyle(theme)}
              href={`/category/${category.id}`}
              className={engFont.className}
            >
              #{category.name}
            </Link>
          ))}
        </CategoryListContainer>
        <IdAndTitleContainer>
          <div css={databaseIdStyle}>#{database.id}</div>
          <div css={databaseTitleStyle}>{database.title}</div>
        </IdAndTitleContainer>
      </div>
      <div css={createdAtAndPostSizeStyle(theme)} className={engFont.className}>
        <div css={createdAtStyle}>作成日 {formatDate(database.createdAt)}</div>
        <div css={postSizeStyle}>
          投稿数 {database.postSize.toLocaleString()}
        </div>
      </div>
    </Link>
  );
};

const CategoryListContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
`;

const IdAndTitleContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

const databaseIdStyle = css`
  ${fixedWidth("4rem")}
  font-size: 20px;
`;

const databaseTitleStyle = css`
  ${fixedWidth("13.5rem")}
  font-size: 24px;
  font-weight: 590;
  line-height: 30px;
`;

const createdAtAndPostSizeStyle = (theme: Theme) => css`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
`;

const createdAtStyle = css`
  font-size: 0.8rem;
`;

const postSizeStyle = css`
  font-size: 1.2rem;
  font-weight: bold;
`;

const rootStyle = (theme: Theme) => css`
  border: 1px solid #eaeaea;
  ${fixedWidth(`calc(${PC_PANEL_WIDTH}px - 2px)`)}
  ${fixedHeight(`calc(${PC_PANEL_WIDTH}px - 2px)`)}
  padding: 1rem;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  background: ${theme.palette.background.default};
`;

const categoryStyle = (theme: Theme) => css`
  color: ${theme.palette.primary.main};
  font-size: 0.8rem;
`;

export default PcDatabasePanel;
